// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".highlight{bottom:0;height:100vh;left:0;overflow-y:hidden;position:fixed;right:0;top:0;transition:all .2s ease-in-out;z-index:2147483646}.highlight--hide{background:transparent 50%/cover no-repeat;pointer-events:none}.highlight--show{background:rgba(0,0,0,.4) 50%/cover no-repeat}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
